import { ReactNode } from "react";

import { Box, Stack, useTheme, Collapse } from "@mui/material";

import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface GiftAidBlockLayoutProps {
  error: boolean;
  isOpen: boolean;
  isAlertOpen: boolean;
  slots: {
    description: ReactNode;
    radio: ReactNode;
    details: ReactNode;
    checkbox: ReactNode;
    alert: ReactNode;
  };
}

export const GiftAidBlockLayout = ({ slots, error, isOpen, isAlertOpen }: GiftAidBlockLayoutProps) => {
  const theme = useTheme();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  const borderColor = error
    ? theme.palette.formsComponents.giftAidBlock.borderErrorColor
    : theme.palette.formsComponents.giftAidBlock.borderColor;

  return (
    <Box
      sx={{
        borderRadius: theme.radius(1),
        border: `1px solid ${borderColor}`,
        backgroundColor: theme.palette.formsComponents.giftAidBlock.backgroundColor,
        color: theme.palette.formsComponents.giftAidBlock.textColor,
      }}
    >
      <Stack padding={theme.spacing(2)}>
        {slots.description}
        {slots.radio}
        <Collapse in={isOpen} easing="ease-in" unmountOnExit>
          <>
            {slots.details}
            {slots.checkbox && (
              <>
                {slots.checkbox}
                <Collapse in={isAlertOpen} easing="ease-in" unmountOnExit>
                  {slots.alert}
                </Collapse>
              </>
            )}
          </>
        </Collapse>
      </Stack>
    </Box>
  );
};
